import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const PALETTE = {
    simulated: {
        fg: "#7a4a38",
        bg: "#f6e6df",
        border: "#e5c3b3",
    },
    live: {
        fg: "#0f4d3a",
        bg: "#dff0e6",
        border: "#a9d3bd",
    },
    "coming-soon": {
        fg: "#5b5b64",
        bg: "#eeeef1",
        border: "#c9c9cf",
    },
};
const DEFAULT_LABEL = {
    simulated: "SIMULATED",
    live: "LIVE",
    "coming-soon": "COMING SOON",
};
export function MockPill({ kind, label }) {
    const p = PALETTE[kind];
    const style = {
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: "3px 8px",
        borderRadius: 999,
        border: `1px solid ${p.border}`,
        backgroundColor: p.bg,
        color: p.fg,
        fontSize: 10,
        fontWeight: 700,
        letterSpacing: "0.14em",
        textTransform: "uppercase",
        lineHeight: 1,
    };
    return (_jsxs("span", { style: style, "data-testid": `mock-pill-${kind}`, children: [kind === "live" ? (_jsx("span", { "aria-hidden": true, style: {
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    background: "#1a8a5a",
                    boxShadow: "0 0 0 3px #d1eadb",
                } })) : null, label ?? DEFAULT_LABEL[kind]] }));
}
